import { Box, SxProps } from '@mui/material';
import { colors } from '../constants/colors';

const classes = {
  root: {
    width: '18px',
    height: '18px',
    minWidth: '18px',
    minHeight: '18px',
    backgroundColor: colors.red,
    borderRadius: '10px',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
};

export interface IExclamationMarkCircleIconProps {
  sx?: SxProps;
}

export const ExclamationMarkCircleIcon = ({
  sx = {},
}: IExclamationMarkCircleIconProps) => {
  return (
    <Box sx={{ ...classes.root, ...sx }}>
      <svg
        width="3"
        height="11"
        viewBox="0 0 3 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.76207 7.82983H0.695406L0.436358 0.742859H2.03636L1.76207 7.82983ZM0.314453 9.8606C0.314453 9.51983 0.400802 9.28038 0.573501 9.14223C0.756358 9.00408 0.974771 8.93501 1.22874 8.93501C1.47255 8.93501 1.68588 9.00408 1.86874 9.14223C2.0516 9.28038 2.14302 9.51983 2.14302 9.8606C2.14302 10.1922 2.0516 10.4316 1.86874 10.579C1.68588 10.7263 1.47255 10.8 1.22874 10.8C0.974771 10.8 0.756358 10.7263 0.573501 10.579C0.400802 10.4316 0.314453 10.1922 0.314453 9.8606Z"
          fill={colors.white}
        />
      </svg>
    </Box>
  );
};
